import _ from 'lodash';
import { RESET_APP, RESET_CART } from '../actions';
import {
  CLEAR_SELECTED_STATIONS,
  RECEIVE_STATIONS,
  SELECT_EXTRA,
  SELECT_STATION,
  UPDATE_RESTRICTED_TIME_SLOTS
} from '../actions/station';

const rawInitialState = {
  stationsData: null,
  selectedStations: {},
  selectedExtra: {},
  restrictedTimeSlots: {}
};

const initialState = () => JSON.parse(JSON.stringify(rawInitialState));

export default (state = initialState(), action) => {
  switch (action.type) {
    case CLEAR_SELECTED_STATIONS:
      return { ...state, selectedStations: {}, selectedExtra: {} };
    case RECEIVE_STATIONS:
      return { ...state, stationsData: action.stations };
    case RESET_CART:
    case RESET_APP:
      return { ...initialState() };
    case SELECT_EXTRA:
      const newSelectedExtra = _.cloneDeep(state.selectedExtra);
      let newSelecteExtraTimeslot = newSelectedExtra[action.timeslotId];
      if (newSelecteExtraTimeslot === undefined) {
        newSelectedExtra[action.timeslotId] = {};
        newSelecteExtraTimeslot = newSelectedExtra[action.timeslotId];
        if (newSelecteExtraTimeslot) {
          newSelecteExtraTimeslot[action.stationId] = action.quantity;
        }
      }
      else {
        newSelecteExtraTimeslot[action.stationId] = action.quantity;
      }
      return { ...state, selectedExtra: newSelectedExtra };
    case SELECT_STATION:
      const newSelected = _.cloneDeep(state.selectedStations);
      let newSelectedTimeslot = newSelected[action.timeslotId];
      if (newSelectedTimeslot === undefined) {
        newSelected[action.timeslotId] = {};
        newSelectedTimeslot = newSelected[action.timeslotId];
        if (newSelectedTimeslot) {
          newSelectedTimeslot[action.stationId] = action.quantity;
        }
      }
      else {
        newSelectedTimeslot[action.stationId] = action.quantity;
        if (action.quantity === 0) {
          let total = 0;
          for (let itm in newSelectedTimeslot) {
            if (newSelectedTimeslot.hasOwnProperty(itm)) {
              let a = newSelectedTimeslot[itm];
              if (a) {
                total += a;
              }
            }
          }
          if (total === 0) {
            delete newSelected[action.timeslotId];
          }
        }
      }

      return { ...state, selectedStations: newSelected };

    case UPDATE_RESTRICTED_TIME_SLOTS:
      return { ...state, restrictedTimeSlots: action.restrictedTimes }
    default:
      return state;
  }

};
